import { combineReducers } from "redux";

import Signup from "./auth/signupReducer";
import Login from "./auth/loginReducer";
import Logout from "./auth/logoutReducer";
import VerifyEmail from "./auth/verifyEmailReducer";
import AddNewAddress from "./auth/addNewAddressReducer";
import GetAddressCard from "./auth/getAddressCardReducer";

import CompleteKYC from "./kyc/completeKYCReducer";
import KYCAuthReducer from "./kyc/kycAuthReducer";

import GetBalance from "./dashboard/getBalanceReducer";
import GetUserData from "./dashboard/getUserdataReducer";
import DepositMoneyPlant from "./dashboard/depositMoneyPlantReducer";
import CryptoPayment from "./payments/cryptoPaymentReducer";

import MonumpayDeposit from "./monumpay/monumpayDepositReducer";
import MonumpayWithdrawal from "./monumpay/monumpayWithdrawalReducer";
import MonumpayWithdrawalRequest from "./monumpay/monumpayWithdrawalRequestReducer";
import BankWireTransfer from "./dashboard/bankWireTransferReducer";

import NGeniusDeposit from "./ngenius/ngeniusDepositReducer";

import EmailWithdraw from "./dashboard/emailWithdrawReducer";
import GetWhitelabel from "./whitelabel/getWhitelabelReducer"
import GetDashboardData from "./dashboard/getDashboardDataReducer";
import GetTransactions from "./dashboard/getTransactionsReducer";
import CreateLiveAccount from "./dashboard/createLiveAccountReducer"
import GetPartnerAccount from "./dashboard/getPartnerAccountReducer"
import TransactionAccounts from "./dashboard/createTransactionAccountReducer"
import Mt5DepositWidthdraw from "./mt5/mt5depositwidthdrawReducer"
import GetUserActivity from "./dashboard/getActivitiesReducer"
import SendProfileData from "./dashboard/sendProfileDataReducer"
import SupportTicket from "./supportTicketReducer"
import TradeOrders from "./dashboard/tradeOrderReducer"
import CorporateSignup from "./corporateSignup/corporateSignupReducer";

const appReducer = combineReducers({
  Signup,
  Login,
  Logout,
  CompleteKYC,
  KYCAuthReducer,
  GetBalance,
  GetUserData,
  DepositMoneyPlant,
  VerifyEmail,
  CryptoPayment,
  AddNewAddress,
  GetAddressCard,
  MonumpayDeposit,
  MonumpayWithdrawal,
  MonumpayWithdrawalRequest,
  BankWireTransfer,
  NGeniusDeposit,
  EmailWithdraw,
  GetWhitelabel,
  GetDashboardData,
  GetTransactions,
  CreateLiveAccount,
  GetPartnerAccount,
  TransactionAccounts,
  Mt5DepositWidthdraw,
  GetUserActivity,
  SendProfileData,
  SupportTicket,
  TradeOrders,
  CorporateSignup,
});

const reducers = (state, action) => {
  // Reset trade orders state on logout
  if (action.type === 'LOGOUT_SUCCESS') {
    return appReducer({ ...state, TradeOrders: { loading: false, tradeOrders: [], pagination: {}, error: null } }, action);
  }
  
  return appReducer(state, action);
};

export default reducers;